import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";

export const useAppStore = defineStore("app", {
  state: () => ({
    isOffline: false,
    standalone: useLocalStorage<boolean>("app.standalone", false),
  }),
  actions: {
    setStandalone(standalone: boolean): void {
      this.standalone = standalone;
    },
    setIsOffline(isOffline: boolean): void {
      this.isOffline = isOffline;
    },
  }
});
